<template>
    <div>
        <el-menu default-active="1" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1">登录日志</el-menu-item>
            <el-menu-item index="2">操作日志</el-menu-item>
            <el-menu-item index="3">异常日志</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content2 v-if="itemVal==2"></v-content2>
        <v-content3 v-if="itemVal==3"></v-content3>
    </div>

</template>

<script>
import $ from 'jquery';
import vContent1 from './syslogs/LogLogin.vue';
import vContent2 from './syslogs/LogOper.vue';
import vContent3 from './syslogs/LogError.vue';
export default {

    data() {
        return {  
           itemVal:'1', 
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        
    },
    components: { 
        vContent1,
        vContent2,
        vContent3
    },

    methods: {
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
};
</script>

<style scoped> 
</style>
